module.exports = exchangeRates;